import f from "../../../../@babel/runtime/helpers/esm/toConsumableArray2.mjs";
import p from "../../../../rc-util/es/hooks/useLayoutEffect.mjs";
import { collectScroller as l, getWin as E } from "../util.mjs";
function h(i, r, n, s) {
  p(function() {
    if (i && r && n) {
      let e = function() {
        s();
      };
      var u = r, c = n, v = l(u), m = l(c), t = E(c), a = new Set([t].concat(f(v), f(m)));
      return a.forEach(function(o) {
        o.addEventListener("scroll", e, {
          passive: !0
        });
      }), t.addEventListener("resize", e, {
        passive: !0
      }), s(), function() {
        a.forEach(function(o) {
          o.removeEventListener("scroll", e), t.removeEventListener("resize", e);
        });
      };
    }
  }, [i, r, n]);
}
export {
  h as default
};
//# sourceMappingURL=useWatch.mjs.map
